import BaseAPI from '../BaseAPI.js'
export default class ContentPagesApi extends BaseAPI {
  _resource ='pages'
}
